import { useRef, useState } from 'react'

export function useComposerMentionRefs() {
  const mentionOpenRef = useRef(false)
  const mentionFlatCountRef = useRef(0)
  const mentionActiveIndexRef = useRef(0)
  const mentionRangeRef = useRef(/** @type {null | { from: number, to: number }} */ (null))
  const [mentionTrigger, setMentionTrigger] = useState(null)
  const [mentionAnchor, setMentionAnchor] = useState(null)
  const [mentionActiveIndex, setMentionActiveIndex] = useState(0)

  return {
    mentionOpenRef,
    mentionFlatCountRef,
    mentionActiveIndexRef,
    mentionRangeRef,
    mentionTrigger,
    setMentionTrigger,
    mentionAnchor,
    setMentionAnchor,
    mentionActiveIndex,
    setMentionActiveIndex,
  }
}
